import Quiz from './LimitedEditingModalQuiz';

const LimitedEditingModal = { Quiz };

export default LimitedEditingModal;
